// Dependencies
import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';

import config from 'react-global-configuration';

import './index.css';
//import App from './App';
import * as serviceWorker from './serviceWorker';

// Routes
import AppRoutes from './routes';

// Assets
import './index.css';

// Variables globales
// ATENCION actualizar uid admin en DB rules
config.set({
    tienda: {
        nombre: "Pizza La Ideal",
        direccion: 'De la Tradicion 361, Ituzaingo'
    },
    // emails de los administradores
    admin: ['gaston22572@gmail.com', 'cubillaosvaldo@hotmail.com']
});


render(
  <Router>
    <AppRoutes />
  </Router>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
